<div class="dplayer-mask"></div>
{{ if options.feedback }}
<div class="dplayer-feedback-wrap dplayer-feedback-wrap-hide">
    <div class="dplayer-feedback-wrap-close">X</div>
    <div class="dplayer-feedback-wrap-content dplayer-feedback-wrap-mult-hide">

    </div>
</div>
{{ /if }}
<div class="yplayer-question-panel">
</div>
{{ if options.endpanel && !isDingDing && !isSSAI }}
<div class="dplayer-endpanel-wrap dplayer-endpanel-wrap-hide">
    <div class="dplayer-endpanel-wrap-content">
        <div class="dplayer-endpanel-logo">{{@ icons.endlogo }}</div>
        {{ if !options.endpanel.feedbackBtn }}
              <div class="dplayer-endpanel-desc">看完了还没掌握？再去看一遍吧～</div>
        {{ /if }}
        {{ if options.endpanel.feedbackBtn && options.feedback}}
              <div class="dplayer-endpanel-desc">看完了还没掌握？再去看一遍吧， <br/>也可以对我们松鼠AI的视频评价反馈哦~</div>
        {{ /if }}
        <div class="dplayer-endpanel-operation">
            <div class="dplayer-endpanel-replay">重播</div>
            {{ if options.endpanel.feedbackBtn && options.feedback}}
                 <div >&nbsp;&nbsp;&nbsp;&nbsp;</div>
                 <div class="dplayer-endpanel-feedback">评论视频</div>
            {{ /if }}
        </div>
    </div>
</div>
{{ /if }}
<div class="dplayer-video-wrap">
    {{ include './video.art' video }}
    {{ if options.logo }}
    <div class="dplayer-logo">
        <img src="{{ options.logo }}">
    </div>
    {{ /if }}
    <div class="dplayer-danmaku"{{ if options.danmaku && options.danmaku.bottm }} style="margin-bottom:{{ options.danmaku.bottm }}"{{ /if }}>
        <div class="dplayer-danmaku-item dplayer-danmaku-item--demo"></div>
    </div>
    <div class="dplayer-subtitle"></div>
    <div class="dplayer-bezel">
        <span class="dplayer-bezel-icon"></span>
        {{ if options.danmaku }}
        <span class="dplayer-danloading">{{ tran('Danmaku is loading') }}</span>
        {{ /if }}
        <span class="diplayer-loading-icon">{{@ icons.loading }}</span>
    </div>

</div>
<div class="dplayer-controller-mask"></div>
<div class="dplayer-controller">
    <div class="dplayer-icons dplayer-comment-box">
        <button class="dplayer-icon dplayer-comment-setting-icon" data-balloon="{{ tran('Setting') }}" data-balloon-pos="up">
            <span class="dplayer-icon-content">{{@ icons.pallette }}</span>
        </button>
        <div class="dplayer-comment-setting-box">
            <div class="dplayer-comment-setting-color">
                <div class="dplayer-comment-setting-title">{{ tran('Set danmaku color') }}</div>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#fff" checked>
                    <span style="background: #fff;"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#e54256">
                    <span style="background: #e54256"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#ffe133">
                    <span style="background: #ffe133"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#64DD17">
                    <span style="background: #64DD17"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#39ccff">
                    <span style="background: #39ccff"></span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-color-{{ index }}" value="#D500F9">
                    <span style="background: #D500F9"></span>
                </label>
            </div>
            <div class="dplayer-comment-setting-type">
                <div class="dplayer-comment-setting-title">{{ tran('Set danmaku type') }}</div>
                <label>
                    <input type="radio" name="dplayer-danmaku-type-{{ index }}" value="1">
                    <span>{{ tran('Top') }}</span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-type-{{ index }}" value="0" checked>
                    <span>{{ tran('Rolling') }}</span>
                </label>
                <label>
                    <input type="radio" name="dplayer-danmaku-type-{{ index }}" value="2">
                    <span>{{ tran('Bottom') }}</span>
                </label>
            </div>
        </div>
        <input class="dplayer-comment-input" type="text" placeholder="{{ tran('Input danmaku, hit Enter') }}" maxlength="30">
        <button class="dplayer-icon dplayer-send-icon" data-balloon="{{ tran('Send') }}" data-balloon-pos="up">
            <span class="dplayer-icon-content">{{@ icons.send }}</span>
        </button>
    </div>
    <div class="dplayer-icons dplayer-icons-left">
        <button class="dplayer-icon dplayer-play-icon">
            <span class="dplayer-icon-content">{{@ icons.play }}</span>
        </button>

        <span class="dplayer-time">
            <span class="dplayer-ptime">0:00</span> /
            <span class="dplayer-dtime">0:00</span>
        </span>
        {{ if options.live }}
        <span class="dplayer-live-badge"><span class="dplayer-live-dot" style="background: {{ options.theme }};"></span>{{ tran('Live') }}</span>
        {{ /if }}
    </div>
    <div class="dplayer-icons dplayer-icons-right">
        {{ if options.feedback }}
             <div class="dplayer-feedback">
               <button class="dplayer-icon dplayer-feedback-icon">
                    <span class="dplayer-icon-content">评价视频</span>
               </button>
             </div>
        {{ /if }}
        {{ if options.video.quality && options.quality }}
        <div class="dplayer-quality">
            <button class="dplayer-icon dplayer-quality-icon">{{ options.video.quality[options.video.defaultQuality].text }}</button>
            <div class="dplayer-quality-mask">
                <div class="dplayer-quality-list">
                {{ each options.video.quality }}
                  {{ if $index == options.video.defaultQuality }}
                  <div class="dplayer-quality-item  dplayer-quality-active " data-index="{{ $index }}">{{ $value.name }}</div>
                  {{else}}
                  <div class="dplayer-quality-item " data-index="{{ $index }}">{{ $value.name }}</div>
                  {{ /if }}
                {{ /each }}
                </div>
            </div>
        </div>
        {{ /if }}
        {{ if options.playbackRates }}
                <div class="dplayer-playback">
                    <button class="dplayer-icon dplayer-playback-icon">1X</button>
                    <div class="dplayer-playback-mask">
                        <div class="dplayer-playback-list">
                        {{ each options.playbackRates }}
                          {{ if $value == 1 }}
                          <div class="dplayer-playback-item  dplayer-playback-active" data-index="{{ $value }}">{{ $value }}X</div>
                          {{else}}
                          <div class="dplayer-playback-item" data-index="{{ $value }}">{{ $value }}X</div>
                          {{ /if }}
                        {{ /each }}
                        </div>
                    </div>
                </div>
        {{ /if }}
        {{ if options.screenshot }}
                <div class="dplayer-icon dplayer-camera-icon" data-balloon="{{ tran('Screenshot') }}" data-balloon-pos="up">
                    <span class="dplayer-icon-content">{{@ icons.camera }}</span>
                </div>
        {{ /if }}
         <div class="dplayer-volume">
                    <button class="dplayer-icon dplayer-volume-icon">
                        <span class="dplayer-icon-content">{{@ icons.volumeDown }}</span>
                    </button>
                    {{ if !options.vertical }}
                    <div class="dplayer-volume-bar-wrap" data-balloon-pos="up">
                        <div class="dplayer-volume-bar">
                            <div class="dplayer-volume-bar-inner" style="background: {{ options.theme }};">
                                <span class="dplayer-thumb" style="background: {{ options.theme }}"></span>
                            </div>
                        </div>
                    </div>
                    {{ /if }}
                    {{ if options.vertical }}
                    <div class="dplayer-volumebar-wrp">
                        <div class ="dplayer-volume-bar-vertical">
                            <div class="dplayer-volume-num">62</div>
                               <div class="dplayer-volumebar bui bui-slider">
                                  <div class="bui-track bui-track-vertical" style="">
                                      <div class="bui-bar-wrap">
                                          <div class="bui-bar bui-bar-normal" style="background: {{ options.theme }};height: 78%;">
                                              <span class="dplayer-volume-control-text"></span>
                                          </div>
                                      </div>
                                  </div>
                               </div>
                        </div>
                    </div>
                    {{ /if }}
         </div>
        {{ if !options.isMobile && options.pictureinpicture }}
        <div class="dplayer-icon dplayer-pictureinpicture-icon" data-balloon="画中画" data-balloon-pos="up">
            <span class="dplayer-icon-content">
                {{@ icons.pictureinpicture }}
            </span>
        </div>
        {{ /if }}
        <div class="dplayer-comment">
            <button class="dplayer-icon dplayer-comment-icon" data-balloon="{{ tran('Send danmaku') }}" data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.comment }}</span>
            </button>
        </div>
        {{ if options.subtitle }}
        <div class="dplayer-subtitle-btn">
            <button class="dplayer-icon dplayer-subtitle-icon" data-balloon="{{ tran('Hide subtitle') }}" data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.subtitle }}</span>
            </button>
        </div>
        {{ /if }}
        {{ if options.live }}
        <div class="dplayer-setting">
            <button class="dplayer-icon dplayer-setting-icon" data-balloon="{{ tran('Setting') }}" data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.setting }}</span>
            </button>
            <div class="dplayer-setting-box">
                <div class="dplayer-setting-origin-panel">
                    <div class="dplayer-setting-item dplayer-setting-speed">
                        <span class="dplayer-label">{{ tran('Speed') }}</span>
                        <div class="dplayer-toggle">{{@ icons.right }}</div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-loop">
                        <span class="dplayer-label">{{ tran('Loop') }}</span>
                        <div class="dplayer-toggle">
                            <input class="dplayer-toggle-setting-input" type="checkbox" name="dplayer-toggle">
                            <label for="dplayer-toggle"></label>
                        </div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-showdan">
                        <span class="dplayer-label">{{ tran('Show danmaku') }}</span>
                        <div class="dplayer-toggle">
                            <input class="dplayer-showdan-setting-input" type="checkbox" name="dplayer-toggle-dan">
                            <label for="dplayer-toggle-dan"></label>
                        </div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-danunlimit">
                        <span class="dplayer-label">{{ tran('Unlimited danmaku') }}</span>
                        <div class="dplayer-toggle">
                            <input class="dplayer-danunlimit-setting-input" type="checkbox" name="dplayer-toggle-danunlimit">
                            <label for="dplayer-toggle-danunlimit"></label>
                        </div>
                    </div>
                    <div class="dplayer-setting-item dplayer-setting-danmaku">
                        <span class="dplayer-label">{{ tran('Opacity for danmaku') }}</span>
                        <div class="dplayer-danmaku-bar-wrap">
                            <div class="dplayer-danmaku-bar">
                                <div class="dplayer-danmaku-bar-inner">
                                    <span class="dplayer-thumb"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dplayer-setting-speed-panel">
                    <div class="dplayer-setting-speed-item" data-speed="0.5">
                        <span class="dplayer-label">0.5x</span>
                    </div>
                    <div class="dplayer-setting-speed-item" data-speed="0.75">
                        <span class="dplayer-label">0.75x</span>
                    </div>
                    <div class="dplayer-setting-speed-item " data-speed="1">
                        <span class="dplayer-label">{{ tran('Normal') }}</span>
                    </div>
                    <div class="dplayer-setting-speed-item" data-speed="1.25">
                        <span class="dplayer-label">1.25x</span>
                    </div>
                    <div class="dplayer-setting-speed-item" data-speed="1.5">
                        <span class="dplayer-label">1.5x</span>
                    </div>
                    <div class="dplayer-setting-speed-item" data-speed="2">
                        <span class="dplayer-label">2x</span>
                    </div>
                </div>
            </div>
        </div>
        {{ /if }}
        {{ if options.light}}
         <div class="dplayer-icon dplayer-light-icon" data-balloon="开灯" data-balloon-pos="up">
                    <span class="dplayer-icon-content">
                        {{@ icons.light_off }}
                    </span>
         </div>
         {{ /if }}
        {{ if options.fullscreen}}
        <div class="dplayer-full">
            {{ if options.fullscreen.fullweb}}
            <button class="dplayer-icon dplayer-full-in-icon" data-balloon="{{ tran('Web full screen') }}" data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.fullWeb }}</span>
            </button>
            {{ /if }}
            {{ if options.fullscreen.full}}
            <button class="dplayer-icon dplayer-full-icon" data-balloon="{{ tran('Full screen') }}" data-balloon-pos="up">
                <span class="dplayer-icon-content">{{@ icons.full }}</span>
            </button>
            {{ /if }}
        </div>
        {{ /if }}
    </div>
    <div class="dplayer-bar-wrap">
        <div class="dplayer-bar-time hidden">00:00</div>
        <div class="dplayer-bar-preview"></div>
        <div class="dplayer-bar">
            <div class="dplayer-loaded" style="width: 0;"></div>
            <div class="dplayer-played" style="width: 0; background: {{ options.theme }}">
                <span class="dplayer-thumb" style="background: {{ options.theme }}"></span>
            </div>
        </div>
    </div>
</div>
<div class="dplayer-info-panel dplayer-info-panel-hide">
    <div class="dplayer-info-panel-close">[x]</div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-version">
        <span class="dplayer-info-panel-item-title">Player version</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-fps">
        <span class="dplayer-info-panel-item-title">Player FPS</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-downlink">
            <span class="dplayer-info-panel-item-title">Connection Speed</span>
            <span class="dplayer-info-panel-item-data"></span>
        </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-type">
        <span class="dplayer-info-panel-item-title">Video type</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div style="display:none;" class="dplayer-info-panel-item dplayer-info-panel-item-url">
        <span class="dplayer-info-panel-item-title">Video url</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div style="display:none;" class="dplayer-info-panel-item dplayer-info-panel-item-source-url">
        <span class="dplayer-info-panel-item-title">Source</span>
        <span contenteditable="true" class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-resolution">
        <span class="dplayer-info-panel-item-title">Video resolution</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-duration">
        <span class="dplayer-info-panel-item-title">Video duration</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    {{ if options.danmaku }}
    <div class="dplayer-info-panel-item dplayer-info-panel-item-danmaku-id">
        <span class="dplayer-info-panel-item-title">Danamku id</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-danmaku-api">
        <span class="dplayer-info-panel-item-title">Danamku api</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    <div class="dplayer-info-panel-item dplayer-info-panel-item-danmaku-amount">
        <span class="dplayer-info-panel-item-title">Danamku amount</span>
        <span class="dplayer-info-panel-item-data"></span>
    </div>
    {{ /if }}
</div>
<div class="dplayer-menu">
    {{ each options.contextmenu }}
        <div class="dplayer-menu-item">
            <a{{ if $value.link }} target="_blank"{{ /if }} href="{{ $value.link || 'javascript:void(0);' }}">{{ tran($value.text) }}</a>
        </div>
    {{ /each }}
</div>
<div class="dplayer-notice"></div>
